var _excluded = ["addButtonText", "addItemTitle", "description", "duplicateItem", "EditItemForm", "editItemTitle", "headingBadge", "headingInfo", "id", "items", "maxItems", "minItems", "onItemAdd", "onItemDelete", "onItemEdit", "onItemsChange", "size", "subject", "title", "titleAs"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import styled from 'styled-components';
import { Sizes } from "../../../constants.js";
import EditItemState from "./components/EditItemState.js";
import ViewListState from "./components/ViewListState.js";
import { getDynamicListGap, getDynamicListPadding, getFont } from "./helpers.js";
var StyledDynamicList = styled.div.withConfig({
  componentId: "CL__sc-kx4q9r-0"
})(["align-items:stretch;background-color:var(--surface-bkg-color);border-radius:var(--border-radius-small);border:1px solid var(--border-color-dim);display:flex;flex-direction:column;font:", ";gap:", ";padding:", ";"], _ref => {
  var {
    size
  } = _ref;
  return getFont(size);
}, _ref2 => {
  var {
    size
  } = _ref2;
  return getDynamicListGap(size);
}, _ref3 => {
  var {
    size
  } = _ref3;
  return getDynamicListPadding(size);
});
var DynamicList = _ref4 => {
  var {
      addButtonText,
      addItemTitle,
      description,
      duplicateItem,
      EditItemForm,
      editItemTitle,
      headingBadge,
      headingInfo,
      id,
      items,
      maxItems,
      minItems,
      onItemAdd,
      onItemDelete,
      onItemEdit,
      onItemsChange,
      size = Sizes.MEDIUM,
      subject = 'Item',
      title,
      titleAs = 'h4'
    } = _ref4,
    htmlAttributes = _objectWithoutProperties(_ref4, _excluded);
  var dynamicListStateProps = {
    addButtonText,
    addItemTitle,
    description,
    duplicateItem,
    EditItemForm,
    editItemTitle,
    headingBadge,
    headingInfo,
    id,
    items,
    maxItems,
    minItems,
    onItemAdd,
    onItemDelete,
    onItemEdit,
    onItemsChange,
    size,
    subject,
    title,
    titleAs
  };
  var [editIndex, setEditIndex] = useState(null);
  return /*#__PURE__*/React.createElement(StyledDynamicList, _extends({
    id: id,
    size: size
  }, htmlAttributes), editIndex === null && /*#__PURE__*/React.createElement(ViewListState, _extends({}, dynamicListStateProps, {
    onEdit: index => setEditIndex(index)
  })), editIndex !== null && /*#__PURE__*/React.createElement(EditItemState, _extends({}, dynamicListStateProps, {
    editIndex: editIndex,
    onComplete: () => setEditIndex(null)
  })));
};
export default DynamicList;